import TextField from "@mui/material/TextField"
import { ICompany, ICompany_group, ICompanyGroup } from "bets.oddprovider.lib.common.ts/models"
import { ApiClientUtils } from "fwork-jsts-common/src/apiClient"
import { FormItemStyled, FormStyled } from "fwork.react.apptemplate/src/components/forms"
import { useSnackbar } from "notistack"
import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import axios from "../../apiClient/axios"
import { CompaniesApiClient } from "../../apiClient/companies"
import { DEFAULTGAP } from "../../globals"
import { FloatActionButton } from "../common/floatActionButton"
import { CompanyGroupsComponent } from "./companyGroups"
import { CommonUtils } from "fwork-jsts-common/src"

export const CompanyComponent = (props: {
  id?: number,
}) => {
  const [data, setData] = useState<ICompany>()
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()

  const [saving, setSaving] = useState<boolean>(false)
  const save = async () => {
    if (saving) return
    setSaving(true)
    try {
      if (data) {
        const response =
          data.id ? await new CompaniesApiClient(axios).put({ data }) : await new CompaniesApiClient(axios).post({ data })
        if (response.success) {
          if (response.data?.id)
            data.id = response.data?.id
          enqueueSnackbar('Alterações salvas com sucesso.', { variant: 'success' })
        }
        else
          enqueueSnackbar(response.msg || 'Erro ao salvar alterações.', { variant: 'error' })
      }
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    }
    finally {
      setSaving(false)
    }
  }

  const getData = async () => {
    try {
      const response = await new CompaniesApiClient(axios).get({
        where: {
          id: Number(props.id)
        },
        nested: 'groups{group}',
        sort: { name: 1 }
      })

      if (response.success && response?.data?.payload) {
        setData(response.data.payload[0])
      }
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    }
  }

  useEffect(() => {
    if (props.id)
      getData()
    else
      setData({
        id: 0,
        name: '',
        database_name: '',
      })
  }, [])

  return <>
    <FormStyled gap={DEFAULTGAP}>
      <FormItemStyled gap={DEFAULTGAP}>
        <TextField
          InputLabelProps={{ shrink: true }}
          value={data?.name || ''}
          label={"Nome da empresa"}
          onChange={(e) => setData({
            ...data,
            name: e.target.value
          } as ICompany)}
        />
      </FormItemStyled>

      <FormItemStyled gap={DEFAULTGAP}>
        <TextField
          InputLabelProps={{ shrink: true }}
          value={data?.database_name || ''}
          label={"Nome do banco de dados"}
          onChange={(e) => setData({
            ...data,
            database_name: e.target.value
          } as ICompany)}
        />
      </FormItemStyled>
    </FormStyled>

    <CompanyGroupsComponent
      data={data?.groups}

      onSelectItem={(c_g: ICompany_group, companyGroup: ICompanyGroup) => {
        let groupsTmp = data?.groups?.filter(g => g.group?.id == companyGroup.id && g.uuid !== c_g.uuid)
        if (groupsTmp?.length) {
          enqueueSnackbar('Grupo já adicionado', { variant: 'error' })
          return
        }
        let companies_groups = [...data?.groups || []]
        for (let oldC_g of companies_groups) {
          if (oldC_g.uuid === c_g.uuid) {
            oldC_g.group_id = companyGroup.id
            oldC_g.group = companyGroup
            break
          }
        }
        setData({
          ...data,
          groups: companies_groups
        } as ICompany)
      }}

      onAddItem={() => {
        const groups = [...data?.groups || []]

        if (groups?.filter(g => g.group_id == 0).length)
          return

        groups.push({
          uuid: CommonUtils.getNewUuid(),
          id: 0,
          company_id: data?.id || 0,
          group_id: 0
        })
        setData({
          ...data,
          groups,
        } as ICompany)
      }}

      onDeleteItem={(item: ICompany_group) => {
        setData({
          ...data,
          groups: data?.groups?.filter(g => g.id ? g.id != item.id : g.uuid != g.uuid)
        } as ICompany)
      }}
    />

    <FloatActionButton progress={saving} onCancelClick={() => navigate(-1)} onConfirmClick={save} />

  </>
}